import { compact } from 'lodash'

const rootUrl = ({ protocol, subdomain } = {}) => {
  let host = window.location.hostname.split('.').slice(-2).join('.')
  if(host === 'netlify.app') host = 'peg.co'

  return (typeof protocol === 'undefined' ? 'https://' : protocol) + compact([subdomain, host]).join('.')
}
export default rootUrl